import IFaq from "../Models/IFaq";

// INFO : last id = 29;

const faq: IFaq = {

    "general_question": {
        "title": "Questions générales",
        "faq_list": [
            { id: 1, question: "Peut-on jouer avant 10 ans ?", response: "La boite ROLETIME est plutôt destinée à des joueurs et joueuses dès 10 ans car les parties peuvent durer plus d'une heure et nécessite un bon niveau de lecture, notamment pour l'utilisation des cartes à jouer." },
            { id: 2, question: "Qu'en est-il de la re-jouabilité ? Le hasard permet-il de changer l'histoire ?", response: "La re-jouabilité se situe au même niveau que tout autre jeu d'aventure ou jeu de rôle. La trame globale du scénario est définitive, et tout comme regarder une nouvelle fois une série TV, rejouer les mêmes épisodes signifie en connaitre les intrigues et le dénouement. Pour autant, à la différence d'une série TV, une bonne partie de la narration provient des joueurs, et donc peut évoluer d'une partie à l'autre ! C'est pour cela que la rejouabilité se situe principalement pour le Meneur ou la Meneuse de Jeu, qui pourra faire jouer l'ensemble des épisodes autant de fois qu'il ou elle aura des joueurs. Très souvent, les joueurs finissent d'ailleurs par devenir les Meneurs et Meneuses des prochaines parties ! Enfin concernant l'aléatoire, même si un D20 est présent dans la boite, l'impact ne permettra pas d'en changer l'histoire principale autant que les décisions des joueurs." },
        ]
    },
    "episodes": {
        1: {
            "title": "Questions : Épisode 1",
            "faq_list": [
            ]
        },
        2: {
            "title": "Questions : Épisode 2",
            "faq_list": [
            ]
        },
        3: {
            "title": "Questions : Épisode 3",
            "faq_list": [
            ]
        },
        4: {
            "title": "Questions : Épisode 4",
            "faq_list": [
            ]
        },
        5: {
            "title": "Questions : Épisode 5",
            "faq_list": [
            ]
        }
    }
}

export default faq;